import script from "./ModalConfirmacion.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalConfirmacion.vue?vue&type=script&setup=true&lang=js"

import "./ModalConfirmacion.vue?vue&type=style&index=0&id=c7ea7cbc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7ea7cbc"]])

export default __exports__